import { Injectable } from '@angular/core';
import { UserLoginResult } from '../../api/auth/user-login-result.model';
import { Organization } from '../../api/organization/organization.model';
import * as moment from 'moment';
import { MyCampApp } from '../../api/common/enumerations';
import CheckInCheckOutActivityType = MyCampApp.CheckInCheckOutActivityType;
// import { UserLoginResult } from '../../shared-api/auth/user-login-result.model';
// import { Organization } from '../../shared-api/organization/organization.model';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageManagerService
{
    private keys = {
        // UserId: 'UserId',
        AccessToken: 'AccessToken',
        AIDialogStyle: "AIDialogStyle",
        ApiEnvironment: 'ApiEnvironment',
        InboundBusMode: 'InboundBusMode',
        OutboundBusMode: 'OutboundBusMode',
        BusModeCategoryIds: 'BusModeCategoryIds',
        BusCheckInCheckOutActivity: 'BusCheckInCheckOutActivity',
        CheckInActivity: 'CheckInActivity',
        CheckInCheckOutDateRange: 'CheckInCheckOutDateRange',
        CheckOutActivity: 'CheckOutActivity',
        CurrentOrganization: 'CurrentOrganization',
        CurrentRoute: 'CurrentRoute',
        RefreshToken: 'RefreshToken',
        ReportDateRange: 'ReportDateRange',
        ShowPhotoDetails: 'ShowPhotoDetails',
        UserLoginResult: 'UserLoginResult',
        UserName: 'UserName',
    };

    constructor() { }


    clearCacheOnSignOut()
    {
        this.userLoginResult = undefined;
        this.currentOrganization = undefined;
    }


    // =========================================================================================================================================================
    // Sign In
    // =========================================================================================================================================================
    get userName(): string
    {
        return localStorage[this.keys.UserName] as string;
    }

    set userName(emailAddress: string)
    {
        localStorage[this.keys.UserName] = emailAddress;
    }

    get showPhotoDetails(): boolean
    {
        return localStorage[this.keys.ShowPhotoDetails] !== 'false';
    }

    set showPhotoDetails(value: boolean)
    {
        localStorage[this.keys.ShowPhotoDetails] = value;
    }

    // Access Token
    get userLoginResult(): UserLoginResult | undefined
    {
        const cachedLoginResult = localStorage[this.keys.UserLoginResult];
        return cachedLoginResult ? JSON.parse(cachedLoginResult) : undefined;
    }

    set userLoginResult(userLoginResult: UserLoginResult | undefined)
    {
        localStorage[this.keys.UserLoginResult] = userLoginResult ? JSON.stringify(userLoginResult) : '';
    }

    get accessToken(): string
    {
        const result = this.userLoginResult;
        return result === undefined ? '' : result.Token;
        // const cachedToken: string = localStorage[this.keys.AccessToken] as string;
        // return cachedToken ? cachedToken : '';
    }

    // Access Token
    get refreshToken(): string
    {
        const result = this.userLoginResult;
        return result === undefined ? '' : result.RefreshToken;
        // const cachedRefreshToken: string = localStorage[this.keys.RefreshToken] as string;
        // return cachedRefreshToken ? cachedRefreshToken : '';
    }

    // // User Id
    // get userId(): number
    // {
    //     return localStorage[this.keys.UserId] ? localStorage[this.keys.UserId] : null;
    // }
    //
    // set userId(userId: number)
    // {
    //     localStorage[this.keys.UserId] = userId;
    // }

    get aiDialogStyle(): string | undefined
    {
        return localStorage[this.keys.AIDialogStyle];
    }

    set aiDialogStyle(position: string | undefined)
    {
        localStorage[this.keys.AIDialogStyle] = position;
    }


    get currentOrganization(): Organization | undefined
    {
        const cachedOrganization = localStorage[this.keys.CurrentOrganization];
        return cachedOrganization && cachedOrganization !== "undefined" ? JSON.parse(cachedOrganization) : undefined;
    }

    set currentOrganization(organization: Organization | undefined)
    {
        localStorage[this.keys.CurrentOrganization] = organization ? JSON.stringify(organization) : undefined;
    }

    // Report Dates
    get reportDates(): Date[] | undefined
    {
        return this.getDateRange(this.keys.ReportDateRange);
    }

    set reportDates(dates: Date[] | undefined)
    {
        this.setDateRange(this.keys.ReportDateRange, dates);
    }

    get checkInActivity(): CheckInCheckOutActivityType | undefined
    {
        return MyCampApp.activityTypeFromString(localStorage[this.keys.CheckInActivity]);
    }
    set checkInActivity(activity: CheckInCheckOutActivityType | undefined)
    {
        localStorage[this.keys.CheckInActivity] = MyCampApp.activityTypeValue(activity);
    }

    get checkOutActivity(): CheckInCheckOutActivityType | undefined
    {
        return MyCampApp.activityTypeFromString(localStorage[this.keys.CheckOutActivity]);
    }
    set checkOutActivity(activity: CheckInCheckOutActivityType | undefined)
    {
        localStorage[this.keys.CheckOutActivity] = MyCampApp.activityTypeValue(activity);
    }

    get busCheckInCheckOutActivity(): CheckInCheckOutActivityType | undefined
    {
        return MyCampApp.activityTypeFromString(localStorage[this.keys.BusCheckInCheckOutActivity]);
    }
    set busCheckInCheckOutActivity(activity: CheckInCheckOutActivityType | undefined)
    {
        localStorage[this.keys.BusCheckInCheckOutActivity] = MyCampApp.activityTypeValue(activity);
    }

    get inboundBusMode(): CheckInCheckOutActivityType | undefined
    {
        return MyCampApp.activityTypeFromString(localStorage[this.keys.InboundBusMode]);
    }
    set inboundBusMode(activity: CheckInCheckOutActivityType | undefined)
    {
        localStorage[this.keys.InboundBusMode] = MyCampApp.activityTypeValue(activity);
    }

    get outboundBusMode(): CheckInCheckOutActivityType | undefined
    {
        return MyCampApp.activityTypeFromString(localStorage[this.keys.OutboundBusMode]);
    }
    set outboundBusMode(activity: CheckInCheckOutActivityType | undefined)
    {
        localStorage[this.keys.OutboundBusMode] = MyCampApp.activityTypeValue(activity);
    }

    get checkInCheckOutCategoryIds(): number[]
    {
        const value = localStorage[this.keys.BusModeCategoryIds];
        return value === undefined ? [] : JSON.parse(value);
    }
    set checkInCheckOutCategoryIds(categoryIds: number[])
    {
        localStorage[this.keys.BusModeCategoryIds] = JSON.stringify(categoryIds);
    }

    get CheckInCheckOutDates(): Date[] | undefined
    {
        return this.getDateRange(this.keys.CheckInCheckOutDateRange);
    }

    set CheckInCheckOutDates(dates: Date[] | undefined)
    {
        this.setDateRange(this.keys.CheckInCheckOutDateRange, dates);
    }

    private getDateRange(key: string): Date[] | undefined
    {
        const datesObjectString = localStorage[key];
        if (datesObjectString === undefined) return undefined;
        const datesObject = JSON.parse(datesObjectString);
        if (datesObject.endDateIsCurrentDay === undefined) return undefined;
        return [ moment(datesObject.startDate).toDate(),
            datesObject.endDateIsCurrentDay ? moment().endOf('day').toDate() : moment(Date.parse(datesObject.endDate)).toDate()];
    }

    private setDateRange(key: string, dates: Date[] | undefined)
    {
        const endDateIsCurrentDay = moment(dates![1]).startOf('day')  === moment().startOf('day');
        localStorage[key] = JSON.stringify(
            {
                endDateIsCurrentDay: endDateIsCurrentDay,
                startDate: moment(dates![0]).toISOString(),
                endDate: moment(dates![1]).toISOString()
            });
    }
}
